import React from 'react';

import {
  ChipField,
  ReferenceArrayField,
  SelectField,
  SingleFieldList,
  TextField,
  useRecordContext,
} from 'react-admin';

import { Grid, Box, Typography } from '@mui/material';
import { isEmpty } from 'lodash';

import { recommendationsChoices } from '../../../../../constants/recommendations';
import { mapBinaryRule } from '../../../ruleFeatures';
import ruleTypes from '../../../../../constants/ruleTypes';
import { Rule } from '../../../../../utilities/schemas/rules';

const booleanChoices = [
  { id: true, name: 'Yes' },
  { id: false, name: 'No' },
];

const RuleResponse = () => {
  const record = useRecordContext<Rule>();
  const createPing = record?.createPing;
  const isAutoConfirmed = record?.isAutoConfirmed;
  const shouldOffsetDeadline = record?.shouldOffsetDeadline;
  const period = record?.deadlineOffset?.unitOfTime;
  const amount = record?.deadlineOffset?.amount;

  return (
    <Grid container spacing={6}>
      {record?.ruleType === ruleTypes.REQUEST && (
        <Grid size={12}>
          <Box display="flex" flexDirection="column">
            <Typography variant="label" color="black" fontWeight="bold">Recommendation</Typography>
            <SelectField choices={recommendationsChoices} source="recommendation" />
          </Box>
        </Grid>
      )}
      {record?.ruleType === ruleTypes.REQUEST && (
        <Grid size={12}>
          <Box display="flex" flexDirection="column">
            <Typography variant="label" color="black" fontWeight="bold">Signals</Typography>
            {!isEmpty(record?.signals) && (
              <ReferenceArrayField source="signals" reference="signals" emptyText="-">
                <SingleFieldList>
                  <ChipField emptyText="-" size="small" source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            )}
            {isEmpty(record?.signals) && (
              <Typography>-</Typography>
            )}
          </Box>
        </Grid>
      )}
      <Grid size={12}>
        <Box display="flex" flexDirection="column">
          <Typography variant="label" color="black" fontWeight="bold">Create ping if error occurs</Typography>
          <SelectField choices={booleanChoices} source="pingOnError" />
        </Box>
      </Grid>
      <Grid size={12}>
        <Box display="flex" flexDirection="column">
          <Typography variant="label" color="black" fontWeight="bold">Create ping</Typography>
          <SelectField choices={booleanChoices} source="createPing" />
        </Box>
      </Grid>
      {createPing && (
        <>
          <Grid size={12}>
            <Box display="flex" flexDirection="column">
              <Typography variant="label" color="black" fontWeight="bold">Should auto confirm ping?</Typography>
              <SelectField choices={booleanChoices} source="isAutoConfirmed" />
            </Box>
          </Grid>
          <Grid size={12}>
            <Box display="flex" flexDirection="column">
              <Typography variant="label" color="black" fontWeight="bold">If Ping is created, should it have a deadline offset?</Typography>
              <TextField record={{ shouldOffsetDeadline: shouldOffsetDeadline ? 'Yes' : 'No' }} source="shouldOffsetDeadline" />
            </Box>
          </Grid>
          {shouldOffsetDeadline && (
            <Grid size={12}>
              <Box display="flex" flexDirection="column">
                <Typography variant="label" color="black" fontWeight="bold">Deadline offset</Typography>
                <TextField record={{ offset: `${amount} ${period}` }} source="offset" />
              </Box>
            </Grid>
          )}
        </>
      )}
      {(createPing && isAutoConfirmed && mapBinaryRule[record?.name!]) && (
        <Grid size={12}>
          <Box display="flex" flexDirection="column">
            <Typography variant="label" color="black" fontWeight="bold">Number of days to ignore?</Typography>
            <TextField source="numberOfDaysIgnoreRule" />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default RuleResponse;
